import { Resume } from '@rio/types'
import { useI18n } from 'builder/hooks/useI18n'
import { SettingsFieldChangeHandler } from 'builder/modules/resumeEditor'
import { useFontSizeField } from 'builder/components/DocumentCustomizationModal/components/ResumeSidebar/hooks/useFontSizesCustomization'
import { useUpdateTemplateSettings } from 'builder/components/DocumentCustomizationModal/components/ResumeSidebar/hooks/useUpdateTemplateSettings'

import { FontSizeFieldIds } from '../types'
import { TEXT_TRANSLATION } from '../constants'

type Props = {
  resume: Resume
}

export const useGetFontSize = (props: Props) => {
  const { i18n } = useI18n()
  const { updateTemplateSettings } = useUpdateTemplateSettings(props.resume)

  const handleTemplateSettingsChange: SettingsFieldChangeHandler = (settingsName, newValue) => {
    updateTemplateSettings({ settingsName, value: newValue })
  }

  const { getFontSizeField } = useFontSizeField(props?.resume, handleTemplateSettingsChange)

  const primaryFontSize = getFontSizeField('fontSizePrimaryHeading')
  const secondaryFontSize = getFontSizeField('fontSizeSecondaryHeading')
  const bodyFontSize = getFontSizeField('fontSizeBody')
  const sectionTitleFontSize = getFontSizeField('fontSizeSectionTitles')

  const getLabel = (field: FontSizeFieldIds) => {
    switch (field) {
      case 'fontSizePrimaryHeading':
        return i18n.t(`${TEXT_TRANSLATION}.primary_heading_label`)
      case 'fontSizeSecondaryHeading':
        return i18n.t(`${TEXT_TRANSLATION}.secondary_heading_label`)
      case 'fontSizeBody':
        return i18n.t(`${TEXT_TRANSLATION}.body_label`)
      case 'fontSizeSectionTitles':
        return i18n.t(`${TEXT_TRANSLATION}.section_titles_label`)
    }
  }

  return {
    primaryFontSize,
    secondaryFontSize,
    bodyFontSize,
    sectionTitleFontSize,
    getFontSizeLabel: getLabel,
    handleSettingsFieldChange: handleTemplateSettingsChange,
  }
}
